import { render, staticRenderFns } from "./UmyMessage.vue?vue&type=template&id=a37d8de0&scoped=true&"
import script from "./UmyMessage.vue?vue&type=script&lang=js&"
export * from "./UmyMessage.vue?vue&type=script&lang=js&"
import style0 from "./UmyMessage.vue?vue&type=style&index=0&id=a37d8de0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37d8de0",
  null
  
)

export default component.exports